import React, { memo } from "react";

import { Checkbox } from "@mui/material";
import {
  useAMGSelectedContext,
  useCurrentPageContext,
  usePageSizeContext,
  useMainGridSortContext,
  useMainGridSortActionContext,
} from "../../../Context/GlobalContext";
import equipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useItemSelectedFilterContext } from "../../../Context/GridEquipListContext";
const TableHeader = memo(({ headers, headerName, pageInfo }) => {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const selectedAnlageG = useAMGSelectedContext();
  const sortBy = useMainGridSortContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const UpdateSortBy = useMainGridSortActionContext();

  function getEquipmentList(itemName) {
    setGlobalSpinner(true);

    equipmentGroupActions.getEquipmentList2(
      "EquipList",
      sortBy.key === itemName
        ? sortBy.order === "asc"
          ? "desc"
          : "asc"
        : "asc",
      selectedAnlageG,
      parseInt(pageInfo.currentpage),
      parseInt(pageInfo.pagSize),
      itemName,
      null,
      itemSelectedFilter
    );
    UpdateSortBy(itemName);
  }
  return (
    <thead>
      <tr>
        {/* <th className="wordRap">
          <Checkbox disabled />
        </th> */}
        {headerName.length > 0 &&
          headers.map((item, index) => {
            if (item.isVisible) {
              return (
                <th
                  className="wordRap"
                  key={index}
                  onClick={() => getEquipmentList(item.name)}
                >
                  <span className="daimler-table-header">
                    {item.text}
                    <span
                      className={
                        sortBy.key.toLowerCase() === item.name.toLowerCase()
                          ? sortBy.className
                          : ""
                      }
                    ></span>
                  </span>
                </th>
              );
            }
            return null;
          })}
      </tr>
    </thead>
  );
});

export default TableHeader;
